jQuery(document).ready(function ($) {
  // primary nav
  $('.nav-primary').accessibleNav({
    desktop: 1025,
    // spans: 'hide',
    level2position: 'vertical-bottom',
    level3position: 'horizontal-right'
  });
  //Nav Functionality - Start
  $('.nav-toggle').click(function (e) {
    openMenu();
    //Hit Escape, close menu
    $(document).on('keyup', function (e) {
      if (e.keyCode === 27) {
        closeMenu();
      }
    });
    //Click outside of open menu, close menu
    $(document).on('click', function (event) {
      if (!$(event.target).closest("header").length) {
        closeMenu();
      }
    });
  });

  $('.nav-toggle').keypress(function (e) {
    openMenu();
    //Hit Escape, close menu
    $(document).on('keyup', function (e) {
      if (e.keyCode === 27) {
        closeMenu();
      }
    });
    //Click outside of open menu, close menu
    $(document).on('click', function (event) {
      if (!$(event.target).closest("header").length) {
        closeMenu();
      }
    });
  });

  //Tab to first link outside of nav menu, close menu
  // $('main a:first').on('focusin', function (event) {
  //   var $target = $(event.target);
  //   if (!$target.closest('.nav-items').length) {
  //     $('body').removeClass('open');
  //     $('.nav-toggle').removeClass('move');
  //     $('span.toggler.open').removeClass('open');
  //   }
  // });

  //Tab to nav-toggle after last link in nav menu to trap focus
  $('.nav-primary a:last').on('focusout', function (event) {
    var $target = $(event.target);
    if (!$target.closest('.nav-items').length) {
      $('.nav-toggle').focus();
    }
  });

  function openMenu() {
    $('body').toggleClass('open');
    $('body').attr('data-attr', 'no-scroll');
    $('.nav-toggle').toggleClass('move');
    $('.nav-primary .ul1 li').first().focus();
    $('span.toggler.open').removeClass('open');
  }

  function closeMenu() {
    $('body').removeClass('open');
    $('body').removeAttr('data-attr');
    $('.nav-toggle').removeClass('move');
    $('.nav-toggle').first().focus();
    $('span.toggler.open').removeClass('open');
  }
  //Nav Functionality - End

  //Nav Placeholder functionality
  $('.nav-primary ul li a:not([href])').click(function () {
    $(this).closest('li').toggleClass('open');
    $(this).next('span.toggler').toggleClass('open');
    $(this).nextAll('ul').toggleClass('open').toggle();
  });

  $('.nav-primary ul li a:not([href])').on('keypress', function (e) {
    if (e.which === 13) {
      $(this).closest('li').toggleClass('open');
      $(this).next('span.toggler').toggleClass('open');
      $(this).nextAll('ul').toggleClass('open').toggle();
    }
  });
  //Nav Placeholder functionality end

  // search
  $('.search-toggle').on('click', function (e) {
    var focusable = $('.site-search');
    if ($('.site-search').hasClass('active')) {
        $('.site-search').removeClass('active');
        $('.site-search').attr('tabindex', '-1');
        destroyTrapNav(focusable);
    } else {
        $('.site-search').addClass('active');
        $('.site-search').attr('tabindex', '0');
        trapNav(focusable);
    }
    if ($(this).hasClass('open')) {
        $(this).removeClass('active');
    } else {
        $(this).addClass('active');
    }
});
$('.search-toggle').on('keydown', function (e) {
    var code = e.keyCode || e.which;
    if (code == 13) {
        var focusable = $('.site-search');
        if ($('.site-search').hasClass('active')) {
            $('.site-search').removeClass('active');
            destroyTrapNav(focusable);
        } else {
            $('.site-search').addClass('active');
            $('.site-search').attr('tabindex', '0');
            trapNav(focusable);
        }
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $(this).addClass('active');
        }
    }
});
  // $('.search-form > button').click(function (e) {
  //   e.preventDefault();
  //   var root = location.protocol + '//' + location.host + '/search-results?search=';
  //   var terms = $('.search-form input[type="search"]').val();
  //   var url = root + terms;
  //   // console.log(url);
  //   window.location.href = url;
  // });
  // $('.search-form input[type="search"]').on('keyup', function (e) {
  //   var root = location.protocol + '//' + location.host + '/search-results?search=';
  //   var terms = $(this).val();
  //   var url = root + terms;
  //   // console.log(url);
  //   if (e.which === 13) {
  //     window.location.href = url;
  //   }
  // });
  // $(".search-form input[type='search']").focusin(function () {
  //   $('.search-form').addClass('active');
  // });
  // $(".search-form input[type='search']").focusout(function () {
  //   $('.search-form').removeClass('active');
  // });

  // add class to select on open
  $('select').on('click', function () {
    $(this).toggleClass('open');
  });
  $('label').on('click', function (e) {
    if ($(this).next().is('select')) {
      e.preventDefault();
      $(this).next('select').focus();
    }
  });
  $(document).on('keyup', function (e) {
    if (e.keyCode === 27) {
      if ($('select').hasClass('open')) {
        $(this).removeClass('open');
      }
    }
  });
  $(window).on('scroll', function () {
    if ($('select').hasClass('open')) {
      $('select').removeClass('open');
    }
  });

  //Open PDF links in new window
  $(function () {
    $('a[href$=".pdf"]').prop('target', '_blank');
  });

  //Open external links in new window
  $(window).load(function () {
    $('a')
      .filter('[href^="http"], [href^="//"]')
      .not('[href*="' + window.location.host + '"]')
      .attr('target', '_blank');
  });

});